import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  BaseThemeType,
  ChevronDownOutlineIcon,
  styled,
  Typography,
  useMediaQuery,
} from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { CheckoutFinancingFilterParameters, CheckoutFinancingPricingParams } from '../types'
import { useGetCheckoutFinanceSystemDetails } from '../utils'
import FinanceMarketplaceFinancingCard from './FinanceMarketplaceFinancingCard'
import FinanceMarketplaceSystemSummary from './FinanceMarketplaceSystemSummary'

type PropTypes = {
  pricingParams: CheckoutFinancingPricingParams
  updatePricingParams: (newParams: CheckoutFinancingPricingParams) => void
  filterParameters: CheckoutFinancingFilterParameters
  isLoading: boolean
}

const Wrapper = styled('div')(({ isMobile }: { isMobile: boolean }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  gap: '16px',
  width: '100%',
}))

const FinanceMarketplaceSummary = (props: PropTypes) => {
  const { pricingParams, updatePricingParams, filterParameters, isLoading } = props
  const { isLoading: systemDetailsLoading, systemDetails } = useGetCheckoutFinanceSystemDetails(
    props.pricingParams.org_id,
    props.pricingParams.project_id,
    props.pricingParams.system_uuid,
    props.pricingParams.payment_option_id
  )
  const isMobile = useMediaQuery((theme: BaseThemeType) => theme.breakpoints.down('sm'))
  const translate = useTranslate()
  return (
    <Wrapper isMobile={isMobile}>
      {isMobile ? (
        <Accordion>
          <AccordionSummary expandIcon={<ChevronDownOutlineIcon />}>
            <div>
              <Typography textVariant="h6">{translate('System Details')}</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <FinanceMarketplaceSystemSummary
              pricingParams={pricingParams}
              isLoading={systemDetailsLoading}
              systemDetails={systemDetails}
            />
          </AccordionDetails>
        </Accordion>
      ) : (
        <FinanceMarketplaceSystemSummary
          pricingParams={pricingParams}
          isLoading={systemDetailsLoading}
          systemDetails={systemDetails}
        />
      )}
      {isMobile ? (
        <Accordion defaultExpanded={true}>
          <AccordionSummary expandIcon={<ChevronDownOutlineIcon />}>
            <div>
              <Typography textVariant="h6">{translate('Customize Financing')}</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <FinanceMarketplaceFinancingCard
              pricingParams={pricingParams}
              updatePricingParams={updatePricingParams}
              filterParameters={filterParameters}
              isLoading={isLoading || systemDetailsLoading}
              systemDetails={systemDetails}
            />
          </AccordionDetails>
        </Accordion>
      ) : (
        <FinanceMarketplaceFinancingCard
          pricingParams={pricingParams}
          updatePricingParams={updatePricingParams}
          filterParameters={filterParameters}
          isLoading={isLoading || systemDetailsLoading}
          systemDetails={systemDetails}
        />
      )}
    </Wrapper>
  )
}

export default FinanceMarketplaceSummary
